import { render, staticRenderFns } from "./ModulePresentItem.vue?vue&type=template&id=406ba28b&scoped=true&"
import script from "./ModulePresentItem.vue?vue&type=script&lang=js&"
export * from "./ModulePresentItem.vue?vue&type=script&lang=js&"
import style0 from "./ModulePresentItem.vue?vue&type=style&index=0&id=406ba28b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406ba28b",
  null
  
)

export default component.exports